module.exports = __webpack_public_path__ + "static/img/fish17.13444b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish/fish17.png
// module id = P6hf
// module chunks = 0